<app-step-timeline
  [steps]="timelineSteps()"
  [config]="{
    variant: 'rail',
    showLines: true,
    showDescriptions: true,
    showTimestamps: false,
    orientation: 'horizontal',
    animated: true,
  }"
  (stepHover)="onStepHover($event)"
  (stepActionClick)="onStepActionExecute($event)"
  (nodeActionClick)="onNodeActionExecute($event)"
/>
